import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CertificatesService} from '../../../organization/components/certificates/certificates.service';
import {Certificate, CertificateDict} from '../../../organization/components/certificates/models';
import {FormBuilder, FormGroup} from '@angular/forms';
import {RxComponent} from '../../../core/components/common/rx.component';
import {Router} from '@angular/router';
import {ConfigService} from '../../../core/services/config.service';

@Component({
    selector: 'itpx-certificate-select',
    templateUrl: './certificate-select.component.html',
    styleUrls: ['./certificate-select.component.css']
})
export class CertificateSelectComponent extends RxComponent implements OnInit {
    certificatesList: any[] = [];
    certificates: CertificateDict[] = [];
    selectedCertificate: CertificateDict;
    selectedCertificateDetails: Certificate;
    form: FormGroup;

    hideCertificateSelection = false;

    isActivated: boolean = false;
    @Input() certificateToSkip: Certificate = null;
    @Input() showToggle: boolean = true;
    @Input() description: string;
    @Input() previewInsteadDownload: boolean = false;
    @Input() title: string = 'Certificates';
    @Input() titleHasOptional: boolean = false;
    @Input() subTitle: string = '';
    @Input() certificate: CertificateDict;
    @Input() certificateDetails: Certificate;
    @Input() certificateTemplateSKU: string;
    @Input() isEditable: boolean = true;
    @Input() isPlatform: boolean = false;
    @Output() certificateSelectedEvent = new EventEmitter<Certificate>();
    @Output() certificateEnabledEvent = new EventEmitter<boolean>();

    constructor(private router: Router,
                private certificatesService: CertificatesService,
                private fb: FormBuilder,
                private configService: ConfigService) {
        super()
    }

    ngOnInit() {

        if (this.router.url.includes("/platform-approvals/courses/")
            || this.router.url.includes("/platform-approvals/assessments/")) {
            this.hideCertificateSelection = true;
        }

        this.form = this.fb.group({
            certificate: [null],
            isActivated: [this.isActivated]
        })

        if (this.certificateDetails && !this.certificate) {
            this.certificate = {
                key: this.certificateDetails.id,
                value: this.certificateDetails.displayName
            }
        }

        if (this.certificate) {
            this.selectedCertificate = this.certificate;
            this.form.get('certificate').setValue(this.certificate.key);
            this.form.get('isActivated').setValue(true);
        }

        if (this.certificateTemplateSKU) {
            this.certificatesService.getCertificateDetailsBySKU(this.certificateTemplateSKU)
                .neverError()
                .bindToLifecycle(this)
                .subscribe((certificateDetails: Certificate) => {
                    this.selectedCertificate = { key: certificateDetails.id, value: certificateDetails.displayName };
                    this.selectedCertificateDetails = certificateDetails;
                    this.form.get('certificate').setValue(certificateDetails.id);
                    this.form.get('isActivated').setValue(true);
                });
        }

        if (!this.hideCertificateSelection) {
        this.certificatesService.getCertificateDictionary()
            .neverError()
            .bindToLifecycle(this)
            .subscribe(data => {
                this.certificates = data;
                this.certificatesList = data.filter(x => !this.certificateToSkip || this.certificateToSkip.id !== x.key).map(d => {
                    return {key: d.key, value: d.value};
                });
                if (this.certificate && this.certificate.key && !this.certificate.value && !this.certificateTemplateSKU) {
                    this.certificate = this.certificatesList.find(x => x.key === this.certificate.key);
                    this.form.patchValue({ certificate: this.certificate.key });
                }
            });
        }

        this.form.get('certificate').valueChanges
            .filter(x => !!x)
            .distinctUntilChanged()
            .bindToLifecycle(this)
            .switchMap(key => this.certificatesService.getCertificateDetails(key))
            .subscribe((certificateDetails: Certificate) => {
                if (!certificateDetails) {
                    return;
                }
                this.selectedCertificate = this.certificates.find(x => x.key === certificateDetails.id);
                this.selectedCertificateDetails = certificateDetails;
                this.certificateSelectedEvent.emit(this.selectedCertificateDetails);
            })

        this.form.get('isActivated').valueChanges
            .bindToLifecycle(this)
            .subscribe(val => {
                this.isActivated = val;
                this.certificateEnabledEvent.emit(val);
                if (!val) {
                    this.form.patchValue({ certificate: null });
                    this.selectedCertificate = null;
                    this.selectedCertificateDetails = null;
                }
            })
    }

    public showCertificates(): boolean {
        return this.showToggle ? this.form.get('isActivated').value : true;
    }

    public openTemplateManagement() {
        this.router.navigate(['organization/certificates']);
    }

    public get dowloadTemplateLink() {
        if (!this.selectedCertificateDetails && !this.certificateDetails) {
            return;
        }
        const certificate = this.selectedCertificateDetails || this.certificateDetails;
        const link = `${this.configService.getSphinxUrlUnsecured('sahara', certificate.s3Bucket, certificate.s3Key)}`;
        return link;
    }
}



// WEBPACK FOOTER //
// ./src/app/common/certificate-select/components/certificate-select.component.ts